import { Accordion, AccordionDetails, Typography } from '@mui/material';
import { memo, useCallback, useMemo, useState } from 'react';
import { AccordionSummary } from 'shell/components/shared/summary-accordion';
import { Check, Close, ExpandMore } from '@mui/icons-material';
import AddressForeignForm from './form';
import { FormikErrors, FormikTouched, useFormikContext } from 'formik';
import { CommonInterfaceSubscription } from 'subscription/view-models/common-interface-subscription';
import { ForeignVM } from 'subscription/view-models/common-interface-subscription';

interface AddressForeignProps {
  isAire?: boolean;
  disabled?: boolean;
}

const AddressForeignComponent = ({
  isAire,
  disabled = false,
}: AddressForeignProps): React.ReactElement => {
  const [open, setOpen] = useState(false);

  const formContext = useFormikContext<CommonInterfaceSubscription>();

  const onFieldAddressForeignChange = useCallback(
    (key, value) => {
      formContext.setFieldValue('addressForeign', {
        ...formContext.values.addressForeign,
        [key]: value,
      });
    },
    [formContext.values.addressForeign, formContext.setFieldValue]
  );

  const errorAddressForeign = useMemo(() => {
    return !!formContext.errors.addressForeign;
  }, [formContext.errors.addressForeign]);

  return isAire ? (
    <Accordion
      expanded={open}
      onChange={() => {
        setOpen(!open);
      }}
    >
      <AccordionSummary
        aria-controls="panel-person-address-foreign-content"
        id="panel-person-address-foreign-header"
        expandIcon={<ExpandMore />}
      >
        {errorAddressForeign ? <Close color="error" /> : <Check color="success" />}
        <Typography>Indirizzo estero</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <AddressForeignForm
          onChange={onFieldAddressForeignChange}
          values={formContext.values.addressForeign}
          disabled={disabled}
          errors={formContext.errors.addressForeign as FormikErrors<ForeignVM>}
          touched={formContext.touched.addressForeign as unknown as FormikTouched<ForeignVM>}
        />
      </AccordionDetails>
    </Accordion>
  ) : (
    <></>
  );
};

AddressForeignComponent.displayName = 'Accordion Address Foreign component';

const AddressForeign = memo(AddressForeignComponent);

export default AddressForeign;
